// extracted by mini-css-extract-plugin
export var RecruitWorks = "RecruitWorks-module--RecruitWorks--3wz9F";
export var RecruitWorks__inner = "RecruitWorks-module--RecruitWorks__inner--YXRxh";
export var RecruitWorks__content = "RecruitWorks-module--RecruitWorks__content--30VqG";
export var RecruitWorks__img = "RecruitWorks-module--RecruitWorks__img--2-U6W";
export var RecruitWorks__text = "RecruitWorks-module--RecruitWorks__text--3eREF";